module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 6
// module chunks = 115